import React from 'react';
import { Link } from 'react-router-dom';
import '../css/Footer.css';

export const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <div className="footer-brand">
          <img src="/weathervaneLogo.svg" alt="Weathervane Intel Logo" />
          <div>
            <h3>Weathervane Intel</h3>
            <p className="footer-tagline">
    Protective Intelligence • OSINT • Crime Analysis
</p>
            <p>
              Protective intelligence, OSINT research, crime mapping, and decision-focused reporting
              for executives, families, advisors, and security teams.
            </p>
          </div>
        </div>

        <nav className="footer-links" aria-label="Footer navigation">
          <div>
            <h4>Company</h4>
            <Link to="/about">About</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/resources">Resources</Link>
          </div>

          <div>
            <h4>Capabilities</h4>
            <Link to="/">Solutions</Link>
            <Link to="/product">Platform</Link>
            <Link to="/intelligence_products">Intelligence Products</Link>
            <Link to="/crime_map_gallery">Crime Maps</Link>
          </div>

          <div>
            <h4>Contact</h4>

            <a href="mailto:info@weathervaneintel.com">
              info@weathervaneintel.com
            </a>

            <a href="tel:2156184273">
              (215) 618-4273
            </a>

            <Link to="/contact">
              Request a Consultation
            </Link>

            <a
              href="https://app.weathervaneintel.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Client Login
            </a>
          </div>
        </nav>
      </div>

      <div className="site-footer-bottom">
        <span>© {new Date().getFullYear()} Weathervane Intel, LLC. All rights reserved.</span>
        <span>Public-source intelligence support. No guarantee of safety or complete risk elimination.</span>
      </div>
    </footer>
  );
};
